document.addEventListener("DOMContentLoaded", function(){
    if (navigator.userAgent.match(/(iPad|iPhone|iPod);/i)) {
		[].forEach.call(document.getElementsByTagName('select'), function(el){el.insertAdjacentHTML('beforeend', '<optgroup></optgroup>');});
	}
});